import { Info } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface HintsToggleProps {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  testId?: string;
}

export function HintsToggle({ id, checked, onCheckedChange, label, testId }: HintsToggleProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        data-testid={testId}
      />
      <Label htmlFor={id} className="text-xs cursor-pointer flex items-center gap-1">
        <Info className="h-3 w-3" />
        {label}
      </Label>
    </div>
  );
}
